import { List } from 'antd';
import { observer } from 'mobx-react-lite';
import { EntityPresentation } from 'src/components/EntityPresentation/EntityPresentation';
import { MasterDetailsAside } from 'src/components/MasterDetailsPage/MasterDetailsAside';
import { MasterDetailsPage } from 'src/components/MasterDetailsPage/MasterDetailsPage';
import { CollateralDto } from 'src/generated-api-client';
import { CollateralListItem } from 'src/pages/CollateralsPage/CollateralListItem';
import { CollateralsHeaderPanel } from 'src/pages/CollateralsPage/CollateralsHeaderPanel';
import { CollateralsStore } from 'src/stores/CollateralsStore/CollateralsStore';

export const CollateralsPage = observer(() => {
    return (
        <MasterDetailsPage
            pageName="collaterals"
            store={store}
            asidePanel={<CollateralsAsidePanel />}
            data-testid="collaterals-page"
        >
            <EntityPresentation store={store} entityName="collateral" />
        </MasterDetailsPage>
    );
});

const CollateralsAsidePanel = observer(() => {
    return (
        <MasterDetailsAside
            store={store}
            renderItem={(item: CollateralDto) => {
                return (
                    <List.Item
                        key={item.id}
                        data-testid={`master-details-list-item-${item.id}`}
                    >
                        <CollateralListItem item={item} />
                    </List.Item>
                );
            }}
            header={<CollateralsHeaderPanel />}
        />
    );
});

const store = CollateralsStore;
